import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DragulaService } from 'ng2-dragula';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { CategoriesActionsComponent } from 'src/app/components/dialog/categories/categories-actions/categories-actions.component';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { CategoriesList, PaginationInput, PaginationPageEvent, ListParams, Lang, Res, ReferenceParams } from 'src/app/models';
import { LanguageService, DialogModalService, NotificationService, PermissionService } from 'src/app/services';
import { ApiCategoriesService } from 'src/app/services/api-categories.service';

export interface Item {
  id: string;
  name: string;
  parent_id: string;
  parent_name: string;
  editable: boolean;
  creatable: boolean;
}

export interface ItemTree {
  id: string;
  name: string;
  parent_id: string;
  checked: boolean;
  children: ItemTree[]
  isOpen: boolean;
}

@Component({
  selector: 'app-tree-view',
  templateUrl: './tree-view.component.html',
  styleUrls: ['./tree-view.component.css']
})
export class TreeViewComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  categories: CategoriesList[] = [];
  filteredCatgory: CategoriesList[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  categorieslength: number;
  items: ItemTree[] = [];
  itemsLoading: boolean;
  actionStatus: boolean;
  editableStatus: boolean = true;
  categoryName: Lang;
  settingVue: boolean;
  dragEnabled = true;
  currentRoute: string;
  categoryAction: string;
  // categoryType: string;
  ffInputLang: any = { name: '', valid: false };
  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  @ViewChildren('element', { read: ElementRef })
  elements: QueryList<ElementRef>;

  @Input() instance: any[] = [];
  @Input() header: boolean;
  @Input() categoryType: string;
  @Input() categoryIds : string[] = [];
  @Input() usageSpace : any;
  @Output() changeItem = new EventEmitter();
  @Output() hiddenCategory = new EventEmitter();

  // @Input() set data(value) {

  //   if (value != null) {

  //    this.categoryType = value.categoryType;
     
  //   }
  // }

  form: UntypedFormGroup = this.fb.group({
    name: [''],
    search: ['']
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private dialogModal: DialogModalService,
    private apiCategoriesService: ApiCategoriesService,
    private notification: NotificationService,
    private router: Router,
    public permissionAccess: PermissionService,
    private dragulaService: DragulaService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {


    this.currentRoute = this.router.url;

   
    if (this.currentRoute == '/settings') {

      this.settingVue = true;

    };

  
    this.progressRef = this.ngProgress.ref('progress-bar');

    if (this.permissionAccess.check('REFERENCES_CATEGORIES')) {

      this.categoriesSwitch(this.categoryType);

    }

    // this.getCategories();

    this.currentRoute = this.router.url;

    this.form.get('search').valueChanges.subscribe(val => {

      this.getCategories(this.categoryType, val, '');

    });


    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.subscriptions.add(
      this.dragulaService.drag('REVERT').subscribe(event => {
        

      })
    )

    this.subscriptions.add(
      this.dragulaService.dropModel("REVERT").subscribe(({ item, targetModel }) => {

        console.log("DRAG ITEM: ", item);


      })
    );

  }

  openWindowWithButton(pop:any)
  {
    pop.open()
  }

  onClose() {

    this.hiddenCategory.emit(false)
    
  }

  /**
   * 
   */
  categoriesSwitch(type: string) {

    switch (type) {

      case 'categories':
        this.categoryAction = 'category';
        this.getCategories(type);
        break;

      case 'files_categories':
        this.categoryAction = 'file_category';
        this.getCategories(type);
        break;

      case 'attrs_for_roles':
        this.categoryAction = 'attrs_for_roles';
        this.getCategories(type);
        break;
    }

  }

  /**
  * 
  * @param fieldName string
  * @param value Lang
  */
  eventFnFF(fieldName: string, value: any): void {

    this.ffInputLang = value;

    this.form.controls[fieldName].setValue(value);
  }


  /**
   * 
   * @param item 
   */
  checkState(item: any) {

    item.checked = !item.checked;
    this.changeItem.emit(item);

    // this.activeModal.close(item)

  }

  /**
   * 
   * @param instance 
   * @param itemToMove 
   * @returns 
   */
  check(instance, itemToMove) {

    if (instance.length > 0) {

      for (let i of instance) {

        if (i.id == itemToMove.id) {

          return false;
        }
        if (i.children.length > 0) {

          if (!this.check(i.children, itemToMove)) {

            return false;
          }
        }

      }
      return true;
    }

  }

  /**
   * 
   * @param item 
   */
  onEdit(item: any): void {

    this.editableStatus = false;
    item['editable'] = true;

    this.subscriptions.add(
      this.apiCategoriesService.edit(this.categoryAction, item.id).subscribe((response: Res) => {

        console.log("EDIT RES: ", response);

        if (response != null) {

          if (response.result != null) {

            this.categoryName = response.result.name;
          }

        }

        this.itemsLoading = false;
      },
        error => {
          this.itemsLoading = false;
        })
    );

  }

  /**
  *
  * @param serachValue string
 */
  onClear(): any {

    this.form.get('search').setValue("");

  }

  /**
   * 
   * @param searchValue - значение для поиска вводимое вручную
   * @param currentElemId - текущее значение из справочника передаваемое при его выборе из списка
   */
  getCategories(categoriesType: string = '', searchValue: string = '', currentElemId: any = ''): void {

    let params: ReferenceParams = {
      ref_name: categoriesType,
      filter: {
        name: searchValue,
        parent_id: currentElemId
      }
    }

    this.itemsLoading = true;
    this.items = [];

    this.subscriptions.add(
      this.apiCategoriesService.getReferences(params, params.ref_name).subscribe((response: Res) => {
        console.log("CATEGORIES: ", response);


        if (response != null && response.result != null) {

          searchValue == '' ? (this.generateCategoryTree(<Item[]>response.result), this.filteredCatgory = []) : (this.categories = response.result, this.filteredCatgory = response.result.filter(item => item.name != null ? item.name.toLowerCase().includes(searchValue) || item.name.includes(searchValue) : []));

          console.log("FILTERED: ", this.filteredCatgory);
          

          this.isOpenItem(this.items);
        }

        this.itemsLoading = false;
      },
        error => {
          this.itemsLoading = false;
        })
    );
  }


  /**
   * 
   */
  isOpenItem(items) {

    let res: boolean = false;

    items.forEach(element => {


      if (element.checked) {

        res = true;
      }

      if (element.children.length > 0) {

        if (this.isOpenItem(element.children)) {

          element.isOpen = true;
          res = true;
        }
      }

    })

    return res;
  }

  /**
  * 
  * @param categories Item[]
  */
  generateCategoryTree(categories: Item[]): void {

    let categoryList: Item[] = [...categories];

    for (let category of categoryList) {

      if (this.searchForParentCategory(category, this.items)) {

        categories = categories.filter(val => val.id != category.id);

        
      }
    }

    if (categories.length > 0 && categories.length != this.categorieslength) {

      this.categorieslength = categories.length;
      this.generateCategoryTree(categories);
    }
  }


  /**
   * 
   * @param category Item
   * @param treeviewItems TreeviewItem[]
   * @returns boolean
   */
  searchForParentCategory(category: Item, treeviewItems: ItemTree[]): boolean {

    if (category.parent_id == null) {

      this.items = this.pushInTreeCategories(category, treeviewItems);

      return true;
    }

    for (let item of treeviewItems) {

      if (item.id == category.parent_id) {

        item.children = this.pushInTreeCategories(category, item.children);
        return true;
      }
      else {

        if (item.children != undefined) {

          if (this.searchForParentCategory(category, item.children)) {

            return true;
          }
        }
      }
    }

    return false;
  }


  /**
   * 
   * @param category Item
   * @param treeviewItems TreeviewItem[]
   * @returns TreeviewItem[]
   */
  pushInTreeCategories(category: Item, treeviewItems: ItemTree[]): ItemTree[] {

    let tvi: any[] = treeviewItems != undefined ? [...treeviewItems] : [];

    tvi.push(
      {
        checked: this.isCheckboxChecked(category),
        isOpen: false,
        id: category.id,
        name: category.name,
        parent_id: category.parent_id,
        children: <ItemTree[]>[]
      }
    )

    return tvi;
  }


  /**
   * 
   * @param category 
   * @returns 
   */
  isCheckboxChecked(category: Item): boolean {

    if (this.categoryIds.length > 0) {

      let treeElem = this.categoryIds.findIndex(val => val == category.id);

      if (treeElem > -1) {

        return true;
      }

      return false;

    }
  }


  /**
   * 
   */
  onTopLevelCreate(): void {

    let data = {

    }

    this.dialogModal.open(data, CategoriesActionsComponent).then(
      (result) => {

        if (result) {

          this.onCreate(result);
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  prepareToCreate(item: Item) {

    this.editableStatus = false;
    item.creatable = true;

    setTimeout(() => this.elements.last.nativeElement.firstChild[1].focus());
  }

  /**
   * 
   * @param item 
   */
  onAction(item: Item) {

    this.categoryName != undefined ? this.onUpdate(item) : this.onCreate(item);
  }

  /**
   * 
   * @param item 
   */
  closeAction(item: Item) {

    this.editableStatus = true;
    item.editable = false;
    item.creatable = false;
    this.categoryName = undefined;
    this.form.controls['name'].setValue("");
  }

  /**
   * 
   * @param item 
   */
  onCreate(item) {

    let data = {
      id: "",
      parent_id: item.id != null ? item.id : null,
      name: this.form.controls['name'].value != "" ? this.form.controls["name"].value : item.name,
      order_num: 1
    }

    this.subscriptions.add(
      this.apiCategoriesService.create(this.categoryAction, data).subscribe((response: Res) => {

        if (response != null) {

          if (item.id != null) {

            item.creatable = false;
            item.isOpen = true;

            item.children.push(
              {
                checked: false,
                id: response.result.id,
                name: this.form.controls['name'].value[this.languageService.defaultLanguage],
                parent_id: item.id,
                children: <ItemTree[]>[]
              }
            );

            this.editableStatus = true;

            // В случае, если перед созданием родительской категории была создана дочерня, то ее наименовие так и остается в форме, 
            // поэтому необходима чистка значения формы и при создании родительской категории в момент сборки объекта 
            // значения будут браться те, которые прилетели из окна, вместо текущих введных в форму
            this.form.controls["name"].setValue("");

          } else {

            this.getCategories(this.categoryType);
          }

          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.itemsLoading = false;
      },
        error => {
          this.itemsLoading = false;
        })
    );

  }
  /**
   * 
   * @param item 
   */
  onUpdate(actionItem, draggalbeItem: any = null) {

    let data: any;

    if (draggalbeItem == null) {

      data = {
        id: actionItem.id,
        parent_id: actionItem.parent_id,
        name: this.form.controls['name'].value,
        order_num: 1
      }
    }

    this.subscriptions.add(
      this.apiCategoriesService.update(this.categoryAction, draggalbeItem != null ? draggalbeItem : data).subscribe((response: Res) => {

        if (response != null) {

          if (draggalbeItem == null) {

            this.editableStatus = true;
            this.categoryName = undefined;
            actionItem.editable = false;
            actionItem.isOpen = true;
            actionItem.name = this.form.controls['name'].value[this.languageService.defaultLanguage];
          }

          this.actionStatus = true;
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.itemsLoading = false;
      },
        error => {
          this.itemsLoading = false;
        })
    );

  }

  /**
   * 
   */
  deleteOne(item: any, list: any[]) {

    this.dialogModal.open('Вы действительно хотите удалить?', ConfirmActionComponent).then(
      (result) => {

        if (result) {

          this.onDelete(item, list);
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
  * 
  * @param ids 
  */
  onDelete(item: any, list?: any[]): void {

    this.progressRef.start();

    console.log("ACTION: ", this.categoryAction);


    this.subscriptions.add(
      this.apiCategoriesService.delete(this.categoryAction, { id: [item.id] }).subscribe(response => {

        if (response != null) {

          let i = list.findIndex(val => val.id == item.id)
          list.splice(i, 1);

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  deleteSelected(): void {

    let ids = [...new Set(this.categories.filter(val => val.checked).map(({ id }) => id))];
    this.onDelete(ids);
  }

  // save(){

  // }

  /**
   * 
   */
  @HostListener('document:click')
  documentClick(): void {

    //  for (let item of this.items) {

    //   if(item.children.length > 0){

    //       for(let ch of item.children){

    //         ch['editable'] = false;
    //       }
    //   }
    //    item['editable']= false;
    //    console.log(item);
    //  }

  }

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.categories[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.categories.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.categories.length == 0) return false;

    return this.categories.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.categories.length;
    let pc = this.categories.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.categories.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }

}
